// extracted by mini-css-extract-plugin
export var aside = "Aside-module--aside--3kF7W";
export var asideNoRule = "Aside-module--asideNoRule--B-7C3";
export var bxTextTruncateEnd = "Aside-module--bx--text-truncate--end--GGWyO";
export var bxTextTruncateFront = "Aside-module--bx--text-truncate--front--mZgZ6";